import { ApiServiceV1 } from '@services/api.service';

const minifyJSON = (jsonStr) => (jsonStr ? JSON.stringify(JSON.parse(jsonStr), null, '') : null);

export default {
  async getTenants({ pageNum = 1, pageSize = 10 }) {
    const { data } = await ApiServiceV1.get('tenant', {
      params: {
        pageNum, pageSize,
      },
    });
    return data.items || [];
  },

  async getAllTenants() {
    const { data } = await ApiServiceV1.get('tenant/all');
    return data || [];
  },

  async getTenantHistory({ tenant, pageNum = 1, pageSize = 10 }) {
    const { data } = await ApiServiceV1.get(`tenant/${tenant}/history`, {
      params: {
        pageNum, pageSize,
      },
    });
    return data.items || [];
  },

  createTenant({ data }) {
    return ApiServiceV1.post('tenant', {
      name: data.name,
      short_name: data.shortName,
      azure_tenant_body: minifyJSON(data.azureTenantBody),
      azure_app_tenant_body: minifyJSON(data.azureAppTenantBody),
    });
  },

  updateTenant({ name, data }) {
    return ApiServiceV1.put(`tenant/${name}`, {
      name: data.name,
      short_name: data.shortName,
      azure_tenant_body: minifyJSON(data.azureTenantBody),
      azure_app_tenant_body: minifyJSON(data.azureAppTenantBody),
    });
  },
};
